import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  & .MuiFormHelperText-root {
    margin: 3px 14px 0px;
  }
`;
